import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { AiCompletionService } from '../../ai-completion.service';

export interface AiRexResult {
    necesidadResuelve?: string;
    comoAyudas?: string;
    porQueEsEspecial?: string;
    resumen?: string;
    rawText?: string;
}

@Component({
    selector: 'app-ai-rex-modal',
    templateUrl: './ai-rex-modal.component.html',
    styleUrls: ['./ai-rex-modal.component.scss']
})
export class AiRexModalComponent implements AfterViewInit {
    @Input() title: string = 'Generar con Rex';
    @Input() subtitle: string = 'Asistente para completar tu información';
    @Input() context: string = '';
    @Input() preguntas: string[] = ['¿Qué necesidad resuelve?', '¿Cómo ayudas?', '¿Por qué es especial?'];
    @Input() result$!: Subject<AiRexResult | null>;

    cargando: boolean = false;
    error: string = '';

    @ViewChild('rexInput') rexInput!: ElementRef<HTMLInputElement>;
    inputFocused: boolean = false;

    constructor(public modalRef: BsModalRef, private ai: AiCompletionService) { }

    ngAfterViewInit(): void {
        setTimeout(() => {
            try { this.rexInput?.nativeElement?.focus(); } catch { }
        }, 200);
    }

    cerrar() {
        if (this.result$) { this.result$.next(null); this.result$.complete(); }
        this.modalRef.hide();
    }

    private parseRespuestas(texto: string): AiRexResult {
        const res: AiRexResult = { rawText: texto };
        // Extraer resumen (texto antes del primer item enumerado)
        const firstEnum = texto.search(/\n?\s*1\)\s/);
        if (firstEnum > -1) {
            let resumen = texto.substring(0, firstEnum).trim();
            resumen = resumen.replace(/^Resumen\s*:\s*/i, '').trim();
            // Quitar saltos extra
            resumen = resumen.replace(/\n+/g, ' ').replace(/\s{2,}/g, ' ').trim();
            res.resumen = resumen;
        }

        const regex = /(?:^|\n)\s*(\d+)\)\s*[^\n]*\n([\s\S]*?)(?=(?:\n\s*\d+\)\s*)|$)/g;
        const sections: { index: number, answer: string }[] = [];
        let m: RegExpExecArray | null;
        while ((m = regex.exec(texto)) !== null) {
            const idx = Number(m[1]);
            const ans = (m[2] || '').trim();
            if (ans) { sections.push({ index: idx, answer: ans }); }
        }
        const by = (i: number) => sections.find(s => s.index === i)?.answer;
        res.necesidadResuelve = by(1);
        res.comoAyudas = by(2);
        res.porQueEsEspecial = by(3);
        return res;
    }

    generar() {
        this.error = '';
        const descripcionActual = this.context || '';
        if (!descripcionActual || descripcionActual.trim().length < 20) {
            this.error = 'Escribe un poco más de contexto (mínimo 20 caracteres).';
            return;
        }

        this.cargando = true;
        const systemPrompt = 'Eres un asistente que responde en español con claridad. Primero escribe un Resumen: de 2-3 frases que describa el proyecto de forma persuasiva. Después, en líneas separadas, responde las preguntas usando el formato 1), 2), 3) y coloca cada respuesta en la línea siguiente.';
        this.ai.generateCompletion(descripcionActual, systemPrompt, this.preguntas).subscribe({
            next: (texto: string) => {
                const parsed = this.parseRespuestas(texto || '');
                if (this.result$) { this.result$.next(parsed); this.result$.complete(); }
                this.modalRef.hide();
            },
            error: () => {
                this.error = 'No se pudo generar con Rex. Inténtalo de nuevo.';
            },
            complete: () => {
                this.cargando = false;
            }
        });
    }
}


